// extracted by mini-css-extract-plugin
module.exports = {"homepage":"HomePage_homepage__Wl1BX","link-game":"HomePage_link-game__3TCIB","link-leaderboard":"HomePage_link-leaderboard__1c6hh"};